import VenueFestival from '../pages/filters/VenueFestival.vue';
import VenueLabels from '../pages/filters/VenueOrganizationType.vue';
import VenueRooms from '../pages/filters/VenueRooms.vue';
import VenueArtisticFields from "../pages/filters/VenueArtisticFields.vue";
import CompanyArtisticFields from "../pages/filters/CompanyArtisticFields.vue";
import CompanyFestival from "../pages/filters/CompanyFestival.vue";
import Networks from "../pages/filters/Networks.vue";

export default [
    {
        name: 'home',
        path: '/',
    },
    {
        name: 'networks',
        path: '/reseaux',
        component: Networks,
    },
    {
        name: 'venue-festival',
        path: '/lieu/festival',
        component: VenueFestival,
    },
    {
        name: 'venue-organization-type',
        path: '/lieu/labels',
        component: VenueLabels,
    },
    {
        name: 'venue-rooms',
        path: '/lieu/salles',
        component: VenueRooms,
    },
    {
        name: 'venue-artistic-fields',
        path: '/lieu/champs-artistiques',
        component: VenueArtisticFields,
    },
    {
        name: 'company-artistic-fields',
        path: '/equipe/champs-artistiques',
        component: CompanyArtisticFields,
    },
    {
        name: 'company-festival',
        path: '/equipe/festival',
        component: CompanyFestival,
    },
]
